import { useMemo } from 'react';
import {Box, Grid, Typography} from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LogoWhite } from '../Logo/Logo';
import HeaderMainProtected from '../Header/HeaderMainProtected';
import { themeSettings } from '../../theme';

export default function PagePublic2Col({ leftsideimage, brandtext, headline, formcomp }) {

  // This page has no light/dark toggle of its own — it must always render
  // light regardless of whatever mode the app was last left in, otherwise
  // a user who switches to dark mode elsewhere gets stuck looking at a dark
  // login screen with no way back.
  const lightTheme = useMemo(() => createTheme(themeSettings('light')), []);

return (
<ThemeProvider theme={lightTheme}>

  <Grid container sx={{ width: '100%', alignItems: 'flex-start', bgcolor: 'background.default' }}>

          {/* LEFT SIDE */}

            <Grid size={{xs:12, lg:6,}} sx={{
              position: { xs: 'relative', lg: 'sticky' },
              top: { lg: 0 },
              height: { xs: 'auto', lg: '100vh' },
              overflow: 'hidden',
              backgroundImage: `url(${leftsideimage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: { xs: 'flex-start', lg: 'space-between' },
              gap: { xs: 2, lg: 0 },
              alignItems: 'flex-start',
              color: 'white',
              minHeight: { xs: '140px', lg: 'unset' },
              p: { xs: 4, lg: 8 },
            }}>

            {/* semi-transparent dark overlay for better readability*/}
            <Box sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1,
            }} />

            {/* Logo at top-left */}
            <Box sx={{ position: 'relative', zIndex: 2 }}>
              <LogoWhite />
            </Box>

            {/* Bottom-left text */}
            <Box sx={{ position: 'relative', zIndex: 2, pr: 2, maxWidth: '100%' }}>
              <Typography variant="h4" sx={{ whiteSpace: { xs: 'nowrap', lg: 'normal' }, fontSize: { xs: '1.5rem' }, letterSpacing: '-0.01em', lineHeight: 1.1 }}>
                {brandtext}
              </Typography>
            </Box>

         </Grid>

   {/* RIGHT SIDE */}
    
      <Grid size={{xs:12, lg:6,}} 
        sx={{ 
            display:'flex', 
            justifyContent:'center', 
            alignItems: { xs: 'flex-start', lg: 'center' },          
            px: { xs: 2, md: 8 },
            py: { xs: 4, md: 2 }, // Padding top/bottom on mobile, center on desktop
            minHeight: '100vh',
            }}
            >
          
          {/* RIGHT SIDE - input form */}

          <Box sx={{width: '100%', maxWidth: {xs:'100%', lg:400}, textAlign: 'center', }}>
            
            {/* Language Toggle Button     
            <Box sx={{mb:4}}> Select Preferred Language:  <br /><LanguageSelector /> </Box>
            */} 
            
            <HeaderMainProtected headline={headline} specify="" />  
           
            <Box sx={{maxWidth: 400, mx: "auto" }}>
              {formcomp}
            </Box>
        
        </Box>

      </Grid>

</Grid>
</ThemeProvider>
  )
}

/* removed
<FooterEnd />
*/